import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-view-for-selection',
  templateUrl: './view-for-selection.component.html',
  styleUrls: ['./view-for-selection.component.scss']
})
export class ViewForSelectionComponent implements OnInit {
  @Output() dataEvent: EventEmitter<number> = new EventEmitter<number>()
  public static readonly defaultValue = -1
  selectedValue: number
  constructor() {}

  ngOnInit(): void {
    this.selectedValue = ViewForSelectionComponent.defaultValue
  }

  onSelectChange(selectedValue: string) {
    this.dataEvent.emit(Number(selectedValue))
  }
}
